import {useSelector} from 'react-redux';

export default () => useSelector(({project}) => project.projectId);
